// -------------------------------------------------------
// CheckoutPay — shared TypeScript types
// -------------------------------------------------------

/** Student assignment flow states */
export enum StudentFlowState {
  INITIAL = 'initial',
  SUGGESTED = 'suggested',
  SEARCHING = 'searching',
  RESULTS = 'results',
  NOT_FOUND = 'not-found',
  CONFIRM = 'confirm',
  ASSIGNED = 'assigned'
}

/** Checkout payment page step */
export enum CheckoutStep {
  ADDRESS = 'address',
  PAYMENT = 'payment'
}

/** How the student was added — determines edit behavior */
export enum StudentSource {
  SEARCH = 'search',
  MANUAL = 'manual'
}

/** Student search tab selection */
export enum SearchTab {
  EASY = 'easy',
  ADVANCED = 'advanced'
}

/** Student search form fields */
export interface StudentSearchFields {
  firstName: string
  lastName: string
  classYear: string
  studentId: string
  email: string
  phone: string
}

/** A single search result item */
export interface StudentSearchResult {
  id: string
  firstName: string
  lastName: string
  school: string
  subjectId: number | null
  isTest?: boolean
}

/** The selected (assigned) student */
export interface SelectedStudent {
  firstName: string
  lastName: string
  classYear: string
  studentId: string
  email: string
  phone: string
  school: string
  subjectId: number | null
}

/** Address form fields */
export interface AddressFields {
  firstName: string
  lastName: string
  addressLine1: string
  addressLine2: string
  zip: string
  city: string
  state: string
}

/** A relationship option chip */
export interface RelationshipOption {
  key: string
  label: string
}

/** A single order summary line item */
export interface OrderLineItem {
  label: string
  price: string
  bold?: boolean
  icon?: string
}

/** A validated discount code with its discount amount */
export interface AppliedDiscount {
  code: string
  amount: number
}
